import { render, staticRenderFns } from "./manage-access-get-list.vue?vue&type=template&id=3a316508&scoped=true"
import script from "./manage-access-get-list.vue?vue&type=script&lang=js"
export * from "./manage-access-get-list.vue?vue&type=script&lang=js"
import style0 from "./manage-access-get-list.vue?vue&type=style&index=0&id=3a316508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a316508",
  null
  
)

export default component.exports